<template>
  <div class="wrapper" v-dragscroll>
    <a href="http://pfotenpiloten.org/" target="_blank"><img src="/img/untermenu/pfotenpiloten.png"></a>
    <a href="https://www.aktion-mensch.de/lotterie/jahreslos" target="_blank"><img src="/img/untermenu/aktionmensch.png"></a>
    <a href="#" v-on:click="changeAudio"><img :src="audiosrc"></a>
    <a href="#" v-on:click="changeLanguage"><img src="/img/untermenu/english.png"></a>
    <a href="#" v-on:click="changeDeaf"><img :src="deafsrc"></a>
  </div>
</template>

<style scoped>
@media (orientation: landscape) and (max-width: 980px) {
  .burger{
    display: none !important;
  }
}
</style>

<style scoped>
.wrapper{
  margin-top:20px;
  height: 100vh;
  z-index:10;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wrapper a{
  width: 100px;
}

.wrapper img{
  display:block;
  width: 100px;
}

@media (orientation: landscape) and (max-width: 980px) {
  .wrapper{
    margin-top:0px;
  }

.wrapper img{
  display:block;
  width: 80px;
}
}

@media (orientation: landscape) and (max-height: 414px) {
.wrapper  img{
    width:83px;
  }
}

@media (orientation: landscape) and (max-height: 411px) {
.wrapper  img{
    width:82px;
  }
}

@media (orientation: landscape) and (max-height: 375px) {
.wrapper  img{
    width:75px;
  }
}

@media (orientation: landscape) and (max-height: 360px) {
.wrapper  img{
    width:72px;
  }
}

@media (orientation: landscape) and (max-height: 320px) {
.wrapper  img{
    width:65px;
  }
}

</style>

<script>
export default {
  name: 'ASSnav',
  mounted () {
    this.$store.state.mute = false
    this.deafsrc = '/img/untermenu/gebaerden.png'
    this.$store.state.srcpath = true
    this.audiosrc = '/img/untermenu/unmute.png'
    this.$store.state.deaf = false
    this.langsrc = '/img/untermenu/english.png'
  },
  data () {
    return {
      deafsrc: '/img/untermenu/gebaerden.png',
      audiosrc: '/img/untermenu/unmute.png'
    }
  },
  methods: {
    changeDeaf () {
      this.$store.state.deaf = !this.$store.state.deaf
      var slider = document.getElementsByClassName('swiper-lazy')
      if (this.$store.state.deaf) {
        this.deafsrc = '/img/untermenu/gebaerden_off.png'
        for (var i = 0; i < slider.length; i++) {
          slider[i].classList.add('swiper-deaf')
        }
      } else {
        for (var g = 0; g < slider.length; g++) {
          this.deafsrc = '/img/untermenu/gebaerden.png'
          slider[g].classList.remove('swiper-deaf')
        }
      }
    },
    changeAudio () {
      this.$store.state.mute = !this.$store.state.mute
      if (this.$store.state.mute) {
        this.audiosrc = '/img/untermenu/mute.png'
      } else {
        this.audiosrc = '/img/untermenu/unmute.png'
      }
    },
    changeLanguage () {
      if (this.$store.state.srcpath === true) {
        this.$store.commit('changeSrcPath', false)
        this.langsrc = '/img/untermenu/deutsch.png'
      } else if (this.$store.state.srcpath === false) {
        this.$store.commit('changeSrcPath', true)
        this.langsrc = '/img/untermenu/english.png'
      }
      this.$store.commit('addUpRerender')
    }
  },
  computed: {
    showSubMenu () {
      return this.$store.state.showSubMenu
    }
  }
}
</script>
